<template v-if="valueIsDefined">
  <span v-if="selectAll">{{ selectAll }}</span>
  <priority-dot
    v-else
    :priority-level="numericValue"
    :priority="objectValue"
    show-label
  />
</template>

<script>

import Vue from 'vue'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot'
import i18n from '@/lang/i18n'
import { isPlainObject } from 'lodash'

export default Vue.extend({
    name: 'StudyRequestPriorityRenderer',
    components: {
        PriorityDot
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        numericValue() {
            return Number(this.params.value)
        },
        objectValue() {
            return isPlainObject(this.params.value) ? this.params.value : null
        },
        selectAll() {
            return this.params.value === i18n.t('component.agGrid.selectAll')
                ? this.params.value : null
        }
    }
})

</script>
